export const SALARIED_EMPLOYEE = {
  extendedForm: true,
  requireIndustry: true,
  requirePi2Questionnaire: true,
  label: 'Salaried Employee',
  value: 'SALARIED_EMPLOYEE'
};
export const HOURLY_EMPLOYEE = {
  extendedForm: true,
  requireIndustry: true,
  requirePi2Questionnaire: true,
  label: 'Hourly Employee',
  value: 'HOURLY_EMPLOYEE'
};
export const SELF_EMPLOYED = {
  extendedForm: true,
  requireIndustry: true,
  requirePi2Questionnaire: true,
  label: 'Self Employed',
  value: 'SELF_EMPLOYED'
};
export const CONTRACTOR = {
  extendedForm: true,
  requireIndustry: true,
  requirePi2Questionnaire: true,
  label: 'Contractor',
  value: 'CONTRACTOR'
};
export const STUDENT = {
  extendedForm: false,
  label: 'Student',
  value: 'STUDENT'
};
export const RETIRED = {
  extendedForm: false,
  label: 'Retired',
  value: 'RETIRED'
};
export const UNEMPLOYED = {
  extendedForm: false,
  label: 'Unemployed',
  value: 'UNEMPLOYED'
};
export const OTHER = {
  extendedForm: false,
  requireIndustry: true,
  requirePi2Questionnaire: true,
  label: 'Other',
  value: 'OTHER'
};
export default [SALARIED_EMPLOYEE, HOURLY_EMPLOYEE, SELF_EMPLOYED, CONTRACTOR, STUDENT, RETIRED, UNEMPLOYED, OTHER];